// extracted by mini-css-extract-plugin
module.exports = {"visualContainer":"_3A_F5L0_GcUUM3KpOKYWI2","blokjesContainer":"_3qv-2s2mWBFPOhx0JeWROT","blokjesRow":"_3AHloOIBZa26wa7tDFVVBg","subcontainer":"_3YhFRuocL-TbnOfRKkI7AT"};